import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 71.36 10.65"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "fill-rule": "evenodd" }, [
      _createElementVNode("path", {
        fill: "#ffd166",
        d: "M2.565 10.609a.363.363 0 0 1-.529-.377l.595-3.408L.11 4.409a.356.356 0 0 1 .2-.611l3.483-.5 1.558-3.1a.367.367 0 0 1 .654 0l1.558 3.1 3.483.5a.356.356 0 0 1 .2.611L8.729 6.823l.595 3.408a.363.363 0 0 1-.529.377L5.68 8.999Zm15 0a.363.363 0 0 1-.529-.377l.595-3.408-2.521-2.415a.356.356 0 0 1 .2-.611l3.483-.5 1.558-3.1a.367.367 0 0 1 .654 0l1.558 3.1 3.483.5a.356.356 0 0 1 .2.611l-2.517 2.414.595 3.408a.363.363 0 0 1-.529.377L20.68 8.999Zm15 0a.363.363 0 0 1-.529-.377l.595-3.408-2.521-2.415a.356.356 0 0 1 .2-.611l3.483-.5 1.558-3.1a.367.367 0 0 1 .654 0l1.558 3.1 3.483.5a.356.356 0 0 1 .2.611l-2.517 2.414.595 3.408a.363.363 0 0 1-.529.377L35.68 8.999Z"
      }),
      _createElementVNode("path", {
        fill: "#e6e8ec",
        d: "M47.565 10.609a.363.363 0 0 1-.529-.377l.595-3.408-2.521-2.415a.356.356 0 0 1 .2-.611l3.483-.5 1.558-3.1a.367.367 0 0 1 .654 0l1.558 3.1 3.483.5a.356.356 0 0 1 .2.611l-2.517 2.414.595 3.408a.363.363 0 0 1-.529.377L50.68 8.999Zm15 0a.363.363 0 0 1-.529-.377l.595-3.408-2.521-2.415a.356.356 0 0 1 .2-.611l3.483-.5 1.558-3.1a.367.367 0 0 1 .654 0l1.558 3.1 3.483.5a.356.356 0 0 1 .2.611l-2.517 2.414.595 3.408a.363.363 0 0 1-.529.377L65.68 8.999Z"
      })
    ], -1)
  ])))
}
export default { render: render }